import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../core/auth.service';

export const redirectLoginGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (authService.getAccessTokenId()) {
    router.navigateByUrl('/admin');
    return false;
  } else {
    return true;
  }
};

/** @deprecated Use the functional `redirectLoginGuard` instead */
export { redirectLoginGuard as RedirectLoginGuard };
